module.exports = __webpack_public_path__ + "static/media/logo.ea9feba8.png";